var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',{staticClass:"v-md-editor__toc-nav"},_vm._l((_vm.titles),function(item,ind){return _c('li',{key:ind,staticClass:"v-md-editor__toc-nav-item",style:({
      paddingLeft: ((_vm.indent * item.indent) + "px"),
    }),on:{"click":function($event){return _vm.$emit('nav-click', item)}}},[_c('span',{staticClass:"v-md-editor__toc-nav-title"},[_vm._v(_vm._s(item.title))])])}),0)}
var staticRenderFns = []

export { render, staticRenderFns }